<template>
    <div class="container">
    <Row>
      <Col span="24" offset="-1" style="background: white;height: 450px;box-shadow: 0.5px 0.5px 3px 0.5px darkgray" >
      <br>
      <br>
      <Col span="10" offset="1" v-if="projectPictureRows!=null && projectPictureRows.length>0">
        <Carousel autoplay loop>
            <CarouselItem v-for="(item,index) in projectPictureRows" :key="index">
            <img :src="item.imgPath" width="100%" >
            </CarouselItem>
        </Carousel>
      </Col>
      <Col span="10" offset="1" v-if="projectPictureRows==null || projectPictureRows.length==0">
        <img :src="img4" width="100%" height="400px">
      </col>
      <Col span="10" offset="1"  align="left" >
       <!--<Button @click="addCollection">收藏</Button>-->
      <Col span="22" style="font-size: 24px;line-height:25px;">
      {{project.projectTitle}}
      </Col>
       <Col span="2"> 
	        <div @click="addCollection()"> <template v-if="2==icon"><Icon type="md-star" size='25' style="color:orange"/></template>
          <template v-if="1==icon"><Icon type="md-star-outline"  size='25' style="color:orange" /></template></div>
       </Col>
      <br/>
      <br/>
      <Col span="10" style="font-size: 14px; ">
      转让底价:<span style="color:red;font-size: 18px;">{{project.money}}</span>万元
      </Col>
      
      <Col span="10" offset="3" style="font-size: 14px; ">所在地：{{project.projectProvince}}
      </Col> 
   
      <br/>
      <br/>
       
      <Col span="10"  style="font-size: 14px;" >
      信息披露期：<span style="color:orange;">{{project.infoDisclosePeriod}}</span>
      </Col>
     
      <Col span="11" offset="3" style="font-size: 14px; ">所属行业：{{project.industry}}
      </Col>  
      
      <br/>
      <br/>
      <Col  span="10" style="font-size: 14px;" >
      保证金： <span style="color:red;">{{project.payDeposit}}</span>
      </Col>
     
      <Col span="10" offset="3" style="font-size: 14px; ">
      经济性质：{{project.economicNature}}
      </Col>
       <br>
      <br>

      <Col offset="5" span="10" style="background: orange; font-size: 25px; ">
      <Icon type="md-call" />
      {{project.phone}}4006-010-661
      </Col>
       <br/>
      <br/>
       <br/>
      <Col>
      <Col  span="15" style="line-height:25px;font-size: 14px; ">
      信息披露开始时间：{{project.infoDiscloseStart}}<br><br>
      信息披露结束时间：{{project.infoDiscloseEnd}}<br>
      </Col>
      </Col>
      <br>
       <br>
       <br>
      <Col span="24"style="border: 1px solid ;border-color: lightgray;background: #f6f6f6;line-height:25px;font-size: 14px;">
          {{projectTxt.projectOutline}}
      </Col>
      </Col>
      </Col>
    </Row>
    <br/>
     <!--<Row>
        <Col span="24" offset="-1" style="background: white;box-shadow: 0.5px 0.5px 3px 0.5px darkgray;height: 110px">
        <Col span="4" class="info" v-for="(item,index) in info" :key="index">{{item}}</Col>
        </Col>
       </Row>-->
       <Row>
        <Col span="24" offset="-1" style="background: white;box-shadow: 0.5px 0.5px 3px 0.5px darkgray;height: 110px">
        <Col span="4" class="info" ><a href="#1" style="font-size:18px;color:black;">转让标的情况</a></Col>
        <Col span="4" class="info" ><a href="#2" style="font-size:18px;color:black;">财务信息</a></Col>
        <Col span="4" class="info" ><a href="#3" style="font-size:18px;color:black;">资产评估情况</a></Col>
        <Col span="4" class="info" ><a href="#4" style="font-size:18px;color:black;">转让方基本情况</a></Col>
        <Col span="5" class="info" ><a href="#5" style="font-size:18px;color:black;">交易条件与受让方基本条件</a></Col>
        <Col span="3" class="info" ><a href="#6" style="font-size:18px;color:black;">其他</a></Col>
        </Col>
       </Row>
       <br/>
    <Row id="1">
      <Col span="24" offset="-1" style="background: white;box-shadow: 0.5px 0.5px 3px 0.5px darkgray;">
      <Col span="5" offset="-1" style="font-size: 23px">
     
      <span style="border-bottom:3px solid orange;font-family: 黑体">转让标的情况</span>
      
      </Col>
      <Divider />

      <Col span="22" offset="1" >
      <table width="100%"  >
        <tr>
          <td>项目名称</td><td>{{projectInfo.projectName}}</td><td>项目编号</td><td>{{projectInfo.projectId}}</td>
        </tr>
        <tr>
          <td>交易机构</td><td colspan="3">{{projectInfo.tradeInstitution}}</td>
        </tr>
        <tr>
          <td>标的企业名称</td><td>{{projectInfo.companyName}}</td><td>法定代表人</td><td>{{projectInfo.legalPerson}}</td>
        </tr>
        <tr>
          <td>注册地</td><td>{{projectInfo.registeredAddress}}</td><td>成立日期</td><td>{{projectInfo.establishmentDate}}</td>
        </tr> <tr>
        <td>注册资本（万元）</td><td>{{projectInfo.registeredCapital}}</td><td>实收资本</td><td>{{projectInfo.paidCapital}}</td>
      </tr>
        <tr>
          <td>经济类型</td><td>{{projectInfo.economicType}}</td><td>企业类型</td><td>{{projectInfo.companyType}}</td>
        </tr> <tr>
        <td>所属行业</td><td>{{projectInfo.industry}}</td><td>统一社会信用代码</td><td>{{projectInfo.unifiedCode}}</td>
      </tr> <tr>
        <td>职工人数</td><td>{{projectInfo.staffNumber}}</td><td>是否含有国有划拨土地</td><td>{{projectInfo.stateOwnedLand}}</td>
      </tr> <tr>
        <td>其他股东是否放弃有限受让权</td><td>{{projectInfo.priorityAssignee}}</td><td>企业管理层是否参与受让</td><td>{{projectInfo.manageAssignee}}</td>
      </tr> <tr>
        <td>是否涉及职工安置</td><td colspan="3">{{projectInfo.staffPlace}}</td>
      </tr> <tr>
        <td>经营规模</td><td  colspan="3" >{{projectTxt.scaleOperation}}</td>
      </tr> <tr>
        <td>经营范围</td><td  colspan="3">{{projectTxt.businessScope}}
      </td>
      </tr> <tr>
        <td>导致标的企业的实际控制权发生转移</td><td  colspan="3">{{projectTxt.transferorPromise}}
        
      </td>
      </tr>
      <tr style="backgrond:white;">
        <td colspan="4" >
      
标的企业股权结构  
      </td>
      </tr>
      <tr><td>前10位股东名称</td><td colspan="3">持股比例</td></tr>
       <tr v-for="item in stockRights"><td>{{item.shareholderName}}</td><td colspan="3">{{item.proportion}}</td></tr>
      </table>
      <br>
      <br>
      </Col>
      </Col>
    </Row>
    <br/>
    <Row id="2">
      <Col span="24" offset="-1" style="background: white;box-shadow: 0.5px 0.5px 3px 0.5px darkgray; ">
       <Col span="4" offset="-1" style="font-size: 23px">
          
      <span style="border-bottom:3px solid orange;font-family: 黑体">财务信息</span>
      
      </Col>
       <Divider />
      <Col offset="1" span="22">
     <table width="100%" >
       <tr><td colspan="7">年度审计报告</td></tr>
          <tr><td>年度</td><td>营业收入（万元）</td><td>营业利润（万元）</td><td>净利润（万元）</td><td>负债总计（万元）</td><td>所有者权益</td><td>审计机构</td></tr>
        <tr v-for="item in finance"><td>{{item.year}}</td><td>{{item.businessIncome}}</td><td>{{item.operatingProfit}}</td><td>{{item.netProfit}}</td><td>{{item.totalLiabilities}}</td>
        <td>{{item.ownerEquity}}</td><td>{{item.auditOrganization}}</td></tr>
         <tr><td colspan="7">重要信息披露</td></tr>
         <tr><td>其他披露内容</td><td colspan="6">{{projectTxt.otherDisclosures}}</td></tr>
          <tr><td>重大债权债务事项</td><td colspan="6">{{projectTxt.greatClaimsDebtMatter}}</td></tr>
     </table>
      <br>
      <br>
      </col>
      </Col>
        </Row>
          <br/>
    <Row id="3">
      <Col span="24" offset="-1" style="background: white;box-shadow: 0.5px 0.5px 3px 0.5px darkgray;height: 700px">
      <Col span="5" offset="-1" style="font-size: 23px">
       <span style="border-bottom:3px solid orange;font-family: 黑体">资产评估情况</span>
      </col>
       <Divider />
       <Col  span="22" offset="1">
       <table width="100%" height="600px"  >
         <tr><td>评估机构</td><td>{{assetsAppraisal.evaluationInstitution}}</td><td>核准备案机构</td><td>{{assetsAppraisal.authorizedInstitution}}</td></tr>
         <tr><td>核准备案日期</td><td>{{assetsAppraisal.authorizedDate}}</td><td>评估基准日</td><td>{{assetsAppraisal.baseDate}}</td></tr>
         <tr><td>基准日审计机构</td><td>{{assetsAppraisal.auditInstitution}}</td><td>录师事务所</td><td>{{assetsAppraisal.lawFirm}}</td></tr>
          <tr><td>内部审议情况</td><td colspan="3">{{assetsAppraisal.internalDeliberations}}</td></tr>
          <tr><td>转让标的的对应估值</td><td colspan="3">{{assetsAppraisal.evaluationValue}}</td></tr>
          <tr style="background:#F5F5F5;"><td>序号</td><td>项目名称</td><td>账面价值（万元）</td><td>评估价值（万元）</td></tr>
          <tr style="background:#ffffff;" v-for="(item,index) in projectAssetValuationDetailsRows" ><td>{{index+1}}</td><td>{{item.placeName}}</td><td>{{item.bookValue}}</td><td>{{item.valuationValue}}</td></tr>
       </table>
       </Col>
      </Col>
      </Row>
       <br/>
    <Row id='4'>
      <Col span="24" offset="-1" style="background: white;box-shadow: 0.5px 0.5px 3px 0.5px darkgray;height: 700px">
         
      <Col span="5" offset="-1" style="font-size: 23px">
      <span style="border-bottom:3px solid orange;font-family: 黑体">转让方基本情况</span>
      </col>
        <Divider />
      <Col span="22" offset='1'>
      <table width="100%" height="500px">
<tr><td colspan="4" style="text-align:left;">转让方基本情况</td></tr>
<tr><td>转让方名称</td><td>{{projectEnterprise.companyName}}</td><td>注册地住所（住所）</td><td>{{projectEnterprise.registeredAddress}}</td></tr>
<tr><td>经济类型</td><td>{{projectEnterprise.economicType}}</td><td>法定代表人</td><td>{{projectEnterprise.legalPerson}}</td></tr>
<tr><td>成立时间</td><td>{{projectEnterprise.establishmentDate}}</td><td>注册资本（万元）</td><td>{{projectEnterprise.registeredCapital}}</td></tr>
<tr><td>所属行业</td><td>{{projectEnterprise.companyType}}</td><td>统一社会信用代码</td><td>{{projectEnterprise.unifiedCode}}</td></tr>
<tr><td>持有产股权比例</td><td>{{projectEnterprise.holdProportion}}</td><td>拟转让产（股）权比例</td><td>{{projectEnterprise.transferProportion}}</td></tr>
<tr><td>经营规模</td ><td colspan="3">{{projectEnterprise.scaleOperation}}</td></tr>
<tr><td colspan="4" style="text-align:left;">产权转让行为批准情况</td></tr>
<tr><td>国家监控机构</td><td>{{projectApproval.regulatoryBody}}</td><td>国家出资企业或主管部门名称</td><td>{{projectApproval.capitalCompanyName}}</td></tr>
<tr><td>统一信用代码</td><td>{{projectApproval.capitalUnifiedCode}}</td><td>转让方决策文件类型</td><td>{{projectApproval.fileType}}</td></tr>
<tr><td>批准单位名称</td><td>{{projectApproval.approveCompanyName}}</td><td>批准日期</td><td>{{projectApproval.approveDate}}</td></tr>
<tr><td>批准单位决策文件类型</td><td>{{projectApproval.approveFileType}}</td><td>决议文件名称</td><td>{{projectApproval.resolutionFile}}</td></tr>
      </table>
      </Col>
      </Col>
      </Row>
       <br/>
    <Row id="5">
      <Col span="24" offset="-1" style="background: white;box-shadow: 0.5px 0.5px 3px 0.5px darkgray;height: 600px">
      <Col span="7" offset="-1" style="font-size: 23px">
       <span style="border-bottom:3px solid orange;font-family: 黑体">交易条件与受让方基本条件</span>
      </col>
        <Divider />
         <Col span="22" offset="1">
      <table width="100%" height="500px">
        <tr><td>标的名称</td><td>{{projectInfo.projectName}}</td><td>转让底价</td><td>{{project.money}}</td></tr>
         <tr><td>价款支付方式</td><td>{{projectPrerequisites.paymentMethod}}</td><td>对转让标的企业职工有无继续</td><td>{{projectPrerequisites.companyWorkers}}</td></tr>
         <tr><td>缴纳保证金</td><td>{{projectPrerequisites.companyWorkers}}</td><td>缴纳金额</td><td>{{projectPrerequisites.payAmount}}</td></tr>
         <tr><td>缴纳时间</td><td>{{projectPrerequisites.payTime}}</td><td>缴纳方式</td><td>{{projectPrerequisites.payMode}}</td></tr>
         <tr><td>对转让标的企业存续发转发发面</td><td colspan="3">{{projectTxt.companySubsist}}</td></tr>
          <tr><td>与转让的相关条件</td><td colspan="3">{{projectTxt.otherConditions}}</td></tr>
            <tr><td>产权转让的债权债务处理</td><td colspan="3">{{projectTxt.debtDisposal}}</td></tr>
              <tr><td>受让方资格条件</td><td colspan="3">{{projectTxt.prerequisites}}</td></tr>
      </table>
      </Col>
      </Col>
     
      </Row>
       <br/>
    <Row id="6"> 
      <Col span="24" offset="-1" style="background: white;box-shadow: 0.5px 0.5px 3px 0.5px darkgray;overflow:hidden;">
      <Col span="3" offset="-1" style="font-size: 23px">
      <span style="border-bottom:3px solid orange;font-family: 黑体">其他</span>
      </col>
        <Divider />
        <Col span="22" offset="1">
        <table width="100%" height="100px">
          <tr><td style="width:30%">采集源地址</td><td style="width:70%;">{{collectAddress[0].attrValue}}</td></tr>
          <tr><td >下载</td><td >
            <span v-for="item in projectAttachmentRows"><a :href="item.attachmentPath">{{item.attachmentName}}</a></span>
            </td></tr>
        </table>
        <br><br>
        </Col>
      </Col>
      </Row>
    </div>

</template>

<script>
  /*  import itable from "./components/table"; */

    export default {
   /*  components: {itable}, */
      data(){
        return{
          project:[],
          stockRights :[],
          projectEnterprise:[],
          projectInfo:[],
          finance:[],
          projectAssetValuationDetailsRows:[],
          projectPictureRows:[],
          projectAttachmentRows:[],
          projectPrerequisites:[],
          projectApproval:[],
          projectTxt:[],
          assetsAppraisal:[],
          Enclosure:[],
          img4:"../../../static/noImg.png",
          dataList: [],
          icon:1,
          collectAddress:[{attrName:'采集源地址',attrValue:''}],
          info:['转让标的基本情况','财务信息','资产评估情况','转让方基本情况','交易条件与受让方基本条件','其他']
        }
      },
      mounted(){
         this.getProject();
      },
      methods:{
     getProject:function(){
       //let that=this;
       let projectId = this.$route.query.detailId;
       protocol.param_projectDetail.data.projectId=projectId;      
       http.gets(protocol.param_projectDetail,protocol.param_projectDetail.data).then(response => {
             let {msg,code,project,projectInfo,projectShareholderRows,projectFinanceRows,projectPrerequisites,
             projectTxt,projectAssetValuation,projectAssetValuationDetailsRows,projectApproval,projectEnterprise,projectAttrRows,projectPictureRows,projectAttachmentRows} = response.data;
             //console.log(msg);
        if (code === 0) {

          if(project!=null){
              this.project = project;
          }
          if(projectInfo!=null){
              this.projectInfo = projectInfo;
          }
          if(projectTxt!=null){
              this.projectTxt = projectTxt;
          }
          //转让方信息
          if(projectEnterprise!=null){
              this.projectEnterprise = projectEnterprise;
          }

          //行为批准情况
          if(projectApproval!=null){
              this.projectApproval = projectApproval;
          }
           //受让条件
          if(projectPrerequisites!=null){
              this.projectPrerequisites = projectPrerequisites;
          }
          
          //资产评估情况
          if(projectAssetValuation!=null){
              this.assetsAppraisal = projectAssetValuation;
          }
          //资产评估明细
          for(let value of projectAssetValuationDetailsRows){


          }
          if(projectAssetValuationDetailsRows!=null){
              this.projectAssetValuationDetailsRows = projectAssetValuationDetailsRows;
          }
          //股权结构
          for(let value of projectShareholderRows){
              let obj = {};
              obj.id= value.id;
            
              obj.shareholderName = value.shareholderName;
              obj.proportion = value.proportion;
              obj.priority = value.priority;
            
              this.stockRights.push(obj);
          }
          //财务信息
          for(let value of projectFinanceRows ){
             let obj = {};
            
           
             obj.type = value.type;
             obj.year = value.year;
             obj.businessIncome = value.businessIncome;
             obj.operatingProfit = value.operatingProfit;
             obj.netProfit = value.netProfit;
             obj.totalAssets = value.totalAssets;
             obj.totalLiabilities= value.totalLiabilities;
             obj.ownerEquity = value.ownerEquity;
             obj.auditOrganization = value.auditOrganization;
             obj.priority = value.priority;
             this.finance.push(obj);
          }
          //自定义属性
          if(projectAttrRows!=null && projectAttrRows.length>0){
                  this.collectAddress = projectAttrRows;
          }
          //图片信息
          if(projectPictureRows!=null && projectPictureRows.length>0){
                  this.projectPictureRows = projectPictureRows;
          }
          //附件信息
          if(projectAttachmentRows!=null && projectAttachmentRows.length>0){
                  this.projectAttachmentRows = projectAttachmentRows;
          }
          
        }else{
          this.dataList = [];
        }
      });
},
addCollection:function(){
    protocol.param_addCollection.data.collectionId=this.$route.query.detailId; ;      
    protocol.param_addCollection.data.type = '1';
    http.posts(protocol.param_addCollection,protocol.param_addCollection.data).then(response => {
         let {msg,code} = response.data;
         if(code=='401'){
            //this.$message({ type: "warning", message: "还未登录，请先登录" });
            //alert("还未登录，请先登录");
            this.$Message.info("还未登录，请先登录");
            this.$router.push({path:'/load'});
          }else if(code==0){
            this.$Message.info(msg);
          }else{
            this.icon=2;
            this.$Message.info(msg);
          }
      });
}
    /*   getProduct () {

          setTimeout(() => {
            this.dataList = this.dataList.find(item => item.id === this.id);
          }, 0);
        }, */

      /*   init() {
          this.$http.get('/api/good').then((response) => {
            response = response.body;
            const ERR_OK = 0;

            if(response.errno === ERR_OK) {
              this.dataList = response.data;
            }
          });
        } */
  }

}
</script>

<style scoped>
 td{
    border: 1px solid lightgray;
    height: 50px;
    font-size: 14px;
  }
  tr{ border: 1px solid lightgray}
  tr:hover{
    background: whitesmoke;
  }
  td:nth-child(2n-1){
    background:#F5F5F5;
    width:240px;

  }
  td:nth-child(2n){
    text-align: left;
     width:240px;
  }


  table{border-collapse: collapse;
    cursor: pointer;
    padding: 5%;
   
  }
    .info{
      line-height:110px; 
      font-size:15px;
       cursor: pointer;
    }
    .info:hover{
      color: orange
     
    }
</style>



// WEBPACK FOOTER //
// src/views/detail/detail.vue